<ng-container *ngIf="isPriceListAllowed">
<div class="rounded w-100 float-left mb-3">
    <div class="w-100 customersearch-title">
        {{ pageTitle$ | async }}
    </div>
</div>
<div class="col-lg-12 bg-white p-0 float-left mt-3 mb-3 border-bottom"
    *ngIf="hasReportFetchAttempted && !isReportLoading && reportRows.length > 0">
    <div class="customersearch-list-table mt-3 float-left col-lg-12 p-0">
        <div
            class="customersearch-list-titles border-top border-bottom float-left w-100 pl-2 pr-2 pt-3 pb-3 d-none d-sm-none d-lg-block">
            <div class="col-md-1 padding-res-0 float-left font-text-600">{{ 'atgPriceList.line' | cxTranslate }}</div>
            <div class="col-md-1 float-left font-text-600">{{ 'atgPriceList.reportId' | cxTranslate }}</div>
            <div class="col-md-2 float-left font-text-600">{{ 'atgPriceList.atgDivision' | cxTranslate }}</div>
            <div class="col-md-1 float-left font-text-600">{{ 'atgPriceList.soldToPartner' | cxTranslate }}</div>
            <div class="col-md-2 float-left font-text-600">{{ 'atgPriceList.soldToName' | cxTranslate }}</div>
            <div class="col-md-2 float-left font-text-600">{{ 'atgPriceList.soldToLocation' | cxTranslate }}</div>
            <div class="col-md-1 float-left font-text-600 cursor-pointer d-flex align-items-center"
                (click)="onSortColumn('createDateTime')" (keyup.enter)="onSortColumn('createDateTime')" tabindex="0"
                style="user-select: none;">
                {{ 'atgPriceList.createDate' | cxTranslate }}
                <span *ngIf="sortField === 'createDateTime'" class="ms-1">
                    <i *ngIf="sortDirection === 'asc'" class="fas fa-arrow-up"></i>
                    <i *ngIf="sortDirection === 'desc'" class="fas fa-arrow-down"></i>
                </span>
            </div>
            <div class="col-md-2 float-left font-text-600 cursor-pointer d-flex align-items-center"
                (click)="onSortColumn('reportStatus')" (keyup.enter)="onSortColumn('reportStatus')" tabindex="0"
                style="user-select: none;">
                {{ 'atgPriceList.reportStatus' | cxTranslate }}
                <span *ngIf="sortField === 'reportStatus'" class="ms-1">
                    <i *ngIf="sortDirection === 'asc'" class="fas fa-arrow-up"></i>
                    <i *ngIf="sortDirection === 'desc'" class="fas fa-arrow-down"></i>
                </span>
            </div>
        </div>

        <div class="bg-white customersearch-list-titles table-content border-bottom float-left w-100 p-2 font-weight-normal d-flex align-items-center"
            *ngFor="let report of reportRows" [attr.aria-hidden]="true">
            <div class="col-md-1 title-wrap padding-res-0 float-left">
                <span class="res-titles">{{ 'atgPriceList.line' | cxTranslate }}:</span> {{ report.line ??
                ('atgPriceList.notAvailable' | cxTranslate) }}
            </div>
            <div class="col-md-1 title-wrap float-left">
                <span class="res-titles">{{ 'atgPriceList.reportId' | cxTranslate }}:</span> {{ report.reportId }}
            </div>
            <div class="col-md-2 title-wrap float-left">
                <span class="res-titles">{{ 'atgPriceList.atgDivision' | cxTranslate }}:</span> {{ report.atgDivision }}
            </div>
            <div class="col-md-1 title-wrap float-left">
                <span class="res-titles">{{ 'atgPriceList.soldToPartner' | cxTranslate }}:</span> {{
                report.soldToPartner }}
            </div>
            <div class="col-md-2 title-wrap float-left">
                <span class="res-titles">{{ 'atgPriceList.soldToName' | cxTranslate }}:</span> {{ report.soldToName }}
            </div>
            <div class="col-md-2 title-wrap float-left">
                <span class="res-titles">{{ 'atgPriceList.soldToLocation' | cxTranslate }}:</span> {{
                report.soldToLocation }}
            </div>
            <div class="col-md-1 title-wrap float-left">
                <span class="res-titles">{{ 'atgPriceList.createDate' | cxTranslate }}:</span> {{ report.createDateTime
                }}
            </div>
            <div class="col-md-2 title-wrap float-left">
                <span class="res-titles">{{ 'atgPriceList.reportStatus' | cxTranslate }}:</span> {{ report.reportStatus
                }}
            </div>
        </div>
    </div>
</div>

<div class="atg-loading-overlay" *ngIf="isReportLoading" aria-live="polite" aria-busy="true">
    <div class="atg-loading-content">
        <cx-spinner></cx-spinner>
    </div>
</div>

<div class="col-lg-12 bg-white p-3 mt-3 mb-3 border-bottom"
    *ngIf="hasReportFetchAttempted && !isReportLoading && reportRows.length === 0">
    <span *ngIf="!hasReportError">{{ 'atgPriceList.noReportDataFound' | cxTranslate }}</span>
    <span *ngIf="hasReportError">{{ 'knBrMessages.error' | cxTranslate }}</span>
</div>

</ng-container>